import { render } from "./IconError.vue?vue&type=template&id=2fe706d3&ts=true"
import script from "./IconError.vue?vue&type=script&lang=ts"
export * from "./IconError.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/widget/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__